import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { delay, map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ListSubscriptions } from '../action-creators';
import {
  CancelMerchSubscriptionSuccess,
  CancelSubscriptionSuccess,
} from '../../subscription/action-creators';
import {
  CANCEL_MERCH_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_SUCCESS,
} from '../../subscription/actions';

export const loadSubscriptionSummaryAfterCancelEpic = (
  action$: Observable<Actions>
) =>
  action$.pipe(
    ofType<Actions, CancelMerchSubscriptionSuccess | CancelSubscriptionSuccess>(
      CANCEL_MERCH_SUBSCRIPTION_SUCCESS,
      CANCEL_SUBSCRIPTION_SUCCESS
    ),
    delay(500),
    map(() => new ListSubscriptions())
  );
